import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow, MaskedLine } from "../components/Reveal";
import { MagneticButton } from "../components/MagneticButton";
import { scrollToSection } from "../hooks/useLenis";

const QUESTIONS = [
    "Are you losing potential customers?",
    "Does your business or ministry look unprofessional online?",
    "Are people having a hard time finding you?",
    "Are you missing opportunities because you're not online?",
    "Tired of answering the same questions on social media?",
    "Does your current online presence actually represent your brand?",
];

export const PainPoints = () => (
    <section id="pain" className="relative py-24 md:py-36" data-testid="pain-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <Eyebrow>The Problem</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-[#0A0F1D] sm:text-5xl lg:text-6xl">
                    STILL WITHOUT<br />A WEBSITE<span className="text-electric-grad">?</span>
                </h2>
            </Reveal>

            <div className="mt-16 md:mt-20">
                {QUESTIONS.map((q, i) => (
                    <motion.div
                        key={q}
                        data-testid={`pain-question-${i}`}
                        className="group flex cursor-default items-baseline gap-6 border-t border-[#0A0F1D]/10 py-7 transition-[padding] duration-500 hover:pl-4 md:py-9"
                        initial={{ opacity: 0, x: i % 2 === 0 ? -48 : 48 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <span className="font-mono text-xs tracking-[0.3em] text-slate-400 transition-colors duration-300 group-hover:text-[#0066FF]">
                            {String(i + 1).padStart(2, "0")}
                        </span>
                        <p className="flex-1 font-display text-xl font-bold leading-snug text-slate-500 transition-colors duration-300 group-hover:text-[#0A0F1D] sm:text-2xl md:text-3xl">
                            {q}
                        </p>
                        <ArrowUpRight className="h-5 w-5 shrink-0 -translate-x-2 translate-y-2 text-sky-400 opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-x-0 group-hover:translate-y-0 group-hover:opacity-100" />
                    </motion.div>
                ))}
                <div className="border-t border-[#0A0F1D]/10" />
            </div>

            <div className="relative mt-24 overflow-hidden border-2 border-[#0A0F1D] bg-[#0A0F1D] px-6 py-16 text-center shadow-[12px_12px_0_rgba(0,102,255,0.8)] md:py-24">
                <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0066FF]/15 blur-[100px]" aria-hidden="true" />
                <h3 className="relative font-display text-4xl font-extrabold tracking-tight sm:text-6xl lg:text-7xl">
                    <MaskedLine play delay={0}>
                        <span className="text-electric-grad">LET&apos;S CHANGE THAT.</span>
                    </MaskedLine>
                </h3>
                <Reveal delay={0.3} className="relative mt-9 flex justify-center">
                    <MagneticButton testid="pain-cta-start" onClick={() => scrollToSection("contact")}>
                        Start The Conversation <ArrowUpRight className="h-4 w-4" />
                    </MagneticButton>
                </Reveal>
            </div>
        </div>
    </section>
);
